import { render, staticRenderFns } from "./OrderCartModal.vue?vue&type=template&id=f15c3258"
import script from "./OrderCartModal.vue?vue&type=script&lang=js"
export * from "./OrderCartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports